import { getDictionaryValues } from "drinkaware-tools-api-library";
import { contentApi } from "@dcc/api";
import { reactive } from "@vue/composition-api";
import { dictionaryFieldMap, DictionaryField } from "./fields";
import { valueNotFoundText } from "./defaultValues";
import { DictionaryText } from "./types";
import Vue from "vue";
import CompositionApi from "@vue/composition-api";
import { DictionaryResponseItem } from "drinkaware-tools-api-library/dist/src/clients/content/src/models";
Vue.use(CompositionApi);
export let dictionary: DictionaryText = reactive({
  ...valueNotFoundText
});
const updateDictionaryFromResponse = (response: DictionaryResponseItem[]) => {
  response.forEach((entry) => {
    if (entry.key && entry.value) {
      dictionary[entry.key as DictionaryField] = entry.value;
    }
  });
};
export const fetchDictionaryValues = async () => {
  try {
    const response = (
      await getDictionaryValues({
        content: contentApi,
        body: {
          keys: dictionaryFieldMap
        }
      })
    ).filter((d: DictionaryResponseItem) => d !== null);
    updateDictionaryFromResponse(response);
  } catch (e) {
    // eslint-disable-next-line
    console.log("An error has occurred in fetchDictionaryValues + ", e);
  }
};
